import * as React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAuth } from '../hooks/useAuth';
import Logo from '../assets/logo-sebrae.png';
import LogoRight from '../assets/logo-sebrae-one.svg';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CustomizedDialogs from '../components/ModalAlert';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useQuery } from '../hooks/useQuery';
import { useSearchParams } from 'react-router-dom';
import { handleHttpError } from '../utils';
import { Step1Cadastro } from './Step1Cadastro';
import { Step2Cadastro } from './Step2Cadastro';
import { Step3Cadastro } from './Step3Cadastro';
import { Step4Cadastro } from './Step4Cadastro';
import { Step5Cadastro } from './Step5Cadastro';
import { CertidoesPage } from './Certidoes';

export const CadastroFornecedorPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const navigate = useNavigate();
  const { handleSubmit, control, watch } = useForm();
  const steps = ['1', '2', '3', '4', '5', '6'];
  const [activeStep, setActiveStep] = React.useState(0);
  const [fornecedor, setFornecedor] = React.useState(null);
  const { showCadastroFornecedor } = useQuery();
  let [searchParams, setSearchParams] = useSearchParams();
  React.useEffect(() => {
    if (searchParams.get('step')) {
      setActiveStep(parseInt(searchParams.get('step')));
    }
  }, []);

  const onSubmit = async (data) => {};

  const renderStepAtual = () => {
    switch (activeStep) {
      case 0:
        return (
          <Step1Cadastro
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      case 1:
        return (
          <Step2Cadastro
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      case 2:
        return (
          <Step3Cadastro
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      case 3:
        return (
          <Step4Cadastro
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      case 4:
        return (
          <Step5Cadastro
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      case 5:
        return (
          <CertidoesPage
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fornecedor={fornecedor}
            setFornecedor={setFornecedor}
          />
        );
      default:
        break;
    }
  };

  return (
    <Grid container spacing={0}>
      <Grid
        item
        sm={12}
        justifyContent={'center'}
        alignItems={'end'}
        display={'flex'}
      >
        <Grid container spacing={0}>
          <Grid
            item
            sm={12}
            style={{
              padding: 80,
              height: '90vh',
              justifyContent: 'center',
              alignItems: 'flex-start',
              display: 'flex',
              overflowY: 'scroll',
            }}
          >
            {renderStepAtual()}
          </Grid>
          <Grid item sm={12} justifyContent={'center'} display={'flex'}>
            <Box sx={{ width: '80%' }}>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                style={{ marginBottom: 0 }}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel></StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
